export default __webpack_public_path__ + "static/media/ListIcon.ed28d423.svg";